import { Routes } from '@dtx-company/true-common/src/constants/routes'

export const REDIRECT_TO_CURR_STORE_PAGE_POST_AUTH_ROUTES = [
  Routes.PRINT_STORE_LANDING_PAGE,
  Routes.MERGED_STORE_PRODUCTS,
  Routes.PRINT_STORE_PRODUCT_TEMPLATES,
  Routes.TEMPLATES_PLACEMENT
]
